import type { Types as FreshchatTypes } from '@mindtickle/ui-shell-core/Freshchat';
import { FRESHCHAT_LOCAL_STORAGE_KEY } from './constant';

export const mtLocalStore = {
  getItem: (key: string) => {
    const item = localStorage.getItem(key);
    return item ? JSON.parse(item) : null;
  },
  setItem: (key: string, value: any) => {
    const serializedValue = JSON.stringify(value);
    localStorage.setItem(key, serializedValue);
  },
};

export function isFreshchatConfig(config: any): config is FreshchatTypes.TFreshchatConfig {
  return config.userId && config.id;
}

export function shouldFreshChatClosed(epochTime: number) {
  const currentTime = Date.now();
  const timeDifference = currentTime - epochTime; // in milliseconds

  const timeDifferenceInMinutes = timeDifference / (1000 * 60);

  return timeDifferenceInMinutes > 11;
}

export const updateFreshchatData = (data: any) => {
  mtLocalStore.setItem(FRESHCHAT_LOCAL_STORAGE_KEY, data || {});
};

export const getFreshchatData = () => {
  const freshchatData = mtLocalStore.getItem(FRESHCHAT_LOCAL_STORAGE_KEY);
  return freshchatData || {};
};
